module.exports = "@media (max-width: 900px) {\n  .breadcrumb-item span {\n    display: none; }\n  .breadcrumb-item span:last-child {\n    display: unset; } }\n\n/* @media (orientation: landscape)\r\n {\r\n.breadcrumb-item{\r\n    span{ display: none;}\r\n    span:last-child {display: unset;}\r\n}\r\n} */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.scss
// module id = ./src/app/shared/components/breadcrumbs/breadcrumbs.component.scss
// module chunks = main